<template>
  <v-app :style="{ backgroundColor: theme.current.value.colors.surface }">
    <ReloadPWA />

    <router-view v-slot="{ Component }">
      <transition name="slide-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <WindowConfig />
  </v-app>
</template>

<script setup lang="ts">
// Vue
import { onMounted } from 'vue';

// Vuetify
import { useTheme } from 'vuetify';
import ThemeUtils from './theme/ThemeUtils';

// Components
import ReloadPWA from './components/pwa/ReloadPWA.vue';
import WindowConfig from './components/shared/WindowConfig.vue';

// Shared
import PWAUtils from './shared/utils/PWAUtils';
import { useTempoTelaComposable } from './services/api/monitoramento-tempo-uso/useTempoTelaComposable';

// Constantes
const theme = useTheme();
useTempoTelaComposable();

onMounted(async () => {
  //window.addEventListener('beforeunload', () => {});

  PWAUtils.initInstaller();
  ThemeUtils.inicializar(theme);
});
</script>

<style>
/* CSS para as transições SLIDE-FADE */

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
